module.exports = __webpack_public_path__ + "static/media/otp.2b80df2f.svg";